export { NOT_AVAILABLE } from "constants/app.constants";

export const FALLBACK_COLOR = "#888";
